import React from "react";

const AllocationModal = ({
  open,
  onClose,
  allocation,
  setAllocation,
  allocationTables,
  onSubmit,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto mx-4">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 flex justify-between items-center rounded-t-xl shadow-md">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
            </svg>
            Customer Allocation
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-blue-100 transition-colors p-1 hover:bg-white/20 rounded-lg"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Customer Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Name
            </label>
            <input
              type="text"
              value={allocation.name}
              onChange={(e) =>
                setAllocation({ ...allocation, name: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter customer name"
            />
          </div>

          {/* Mobile Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mobile Number
            </label>
            <input
              type="tel"
              maxLength={10}
              value={allocation.phone}
              onChange={(e) =>
                setAllocation({
                  ...allocation,
                  phone: e.target.value.replace(/\D/g, ""),
                })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter 10-digit mobile number"
            />
          </div>

          {/* Customer Count */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Count
            </label>
            <input
              type="text"
              inputMode="numeric"
              value={allocation.customerCount}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "");
                setAllocation({
                  ...allocation,
                  customerCount: digits === "" ? "" : Number(digits),
                });
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Number of customers"
            />
          </div>

          {/* Table Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Table Number
            </label>
            <select
              value={allocation.tableNumber}
              disabled={!!allocation.tableNumber}
              onChange={(e) =>
                setAllocation({ ...allocation, tableNumber: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">Select a table</option>
              {allocationTables.map((t) => (
                <option key={t._id} value={t.tableNumber}>
                  {t.tableNumber}
                </option>
              ))}
            </select>
          </div>

          {/* Submit Button */}
          <button
            onClick={onSubmit}
            className="w-full mt-6 px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02]"
          >
            Allocate Table
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllocationModal;
